//gemini: In page 1 of this pdf, return market updates for detached, condo, townhomess, for feb of 2025 2024 and one-year-change in json format of {"February 2025": { "Vancouver East": {detached: {"total_active_listings": {"2025": 537, "2024": 410, "one-year-change": "+31.0%"}}}}}. dont need to process table with JAnuary header. do the same for all of these files and add them to this json
export const marketDataGVRpercityAllMonths = {
	'February 2025': {
		'Burnaby North': {
			detached: {
				total_active_listings: {
					2025: '144',
					2024: '86',
					'one-year-change': '+67.4%'
				},
				sales: {
					2025: '18',
					2024: '16',
					'one-year-change': '+12.5%'
				},
				days_on_market_average: {
					2025: '44',
					2024: '52',
					'one-year-change': '-15.4%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,085,400',
					2024: '$2,049,200',
					'one-year-change': '+1.8%'
				}
			},
			condo: {
				total_active_listings: {
					2025: '530',
					2024: '328',
					'one-year-change': '+61.6%'
				},
				sales: {
					2025: '94',
					2024: '85',
					'one-year-change': '+10.6%'
				},
				days_on_market_average: {
					2025: '33',
					2024: '33',
					'one-year-change': '0.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$732,000',
					2024: '$761,400',
					'one-year-change': '-3.9%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: '44',
					2024: '36',
					'one-year-change': '+22.2%'
				},
				sales: {
					2025: '12',
					2024: '19',
					'one-year-change': '-36.8%'
				},
				days_on_market_average: {
					2025: '12',
					2024: '33',
					'one-year-change': '-63.6%'
				},
				mls_hpi_benchmark_price: {
					2025: '$911,000',
					2024: '$907,300',
					'one-year-change': '+0.4%'
				}
			}
		},
		tsawaassen: {
			detached: {
				total_active_listings: {
					2025: 124,
					2024: 79,
					'one-year-change': '+57.0%'
				},
				sales: {
					2025: 6,
					2024: 11,
					'one-year-change': '-45.5%'
				},
				days_on_market_average: {
					2025: 32,
					2024: 54,
					'one-year-change': '-40.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,654,800',
					2024: '$1,554,600',
					'one-year-change': '+6.4%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 79,
					2024: 39,
					'one-year-change': '+102.6%'
				},
				sales: {
					2025: 15,
					2024: 15,
					'one-year-change': '0.0%'
				},
				days_on_market_average: {
					2025: 47,
					2024: 32,
					'one-year-change': '+46.9%'
				},
				mls_hpi_benchmark_price: {
					2025: '$619,200',
					2024: '$680,900',
					'one-year-change': '-9.1%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 37,
					2024: 23,
					'one-year-change': '+60.9%'
				},
				sales: {
					2025: 6,
					2024: 8,
					'one-year-change': '-25.0%'
				},
				days_on_market_average: {
					2025: 33,
					2024: 25,
					'one-year-change': '+32.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,007,800',
					2024: '$1,007,700',
					'one-year-change': '+0.0%'
				}
			}
		},
		whistler: {
			detached: {
				total_active_listings: {
					2025: 86,
					2024: 71,
					'one-year-change': '+21.1%'
				},
				sales: {
					2025: 5,
					2024: 5,
					'one-year-change': '0.0%'
				},
				days_on_market_average: {
					2025: 98,
					2024: 101,
					'one-year-change': '-3.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,159,300',
					2024: '$2,312,500',
					'one-year-change': '-6.6%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 103,
					2024: 92,
					'one-year-change': '+12.0%'
				},
				sales: {
					2025: 27,
					2024: 28,
					'one-year-change': '-3.6%'
				},
				days_on_market_average: {
					2025: 52,
					2024: 47,
					'one-year-change': '+10.6%'
				},
				mls_hpi_benchmark_price: {
					2025: '$588,000',
					2024: '$736,000',
					'one-year-change': '-20.1%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 73,
					2024: 69,
					'one-year-change': '+5.8%'
				},
				sales: {
					2025: 8,
					2024: 11,
					'one-year-change': '-27.3%'
				},
				days_on_market_average: {
					2025: 93,
					2024: 29,
					'one-year-change': '+220.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,384,800',
					2024: '$1,643,200',
					'one-year-change': '-15.7%'
				}
			}
		},
		squamish: {
			detached: {
				total_active_listings: {
					2025: '58',
					2024: '72',
					'one-year-change': '-19.4%'
				},
				sales: {
					2025: '18',
					2024: '18',
					'one-year-change': '0.0%'
				},
				days_on_market_average: {
					2025: '82',
					2024: '35',
					'one-year-change': '+134.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,464,000',
					2024: '$1,464,500',
					'one-year-change': '-0.0%'
				}
			},
			condo: {
				total_active_listings: {
					2025: '64',
					2024: '49',
					'one-year-change': '+30.6%'
				},
				sales: {
					2025: '10',
					2024: '5',
					'one-year-change': '+100.0%'
				},
				days_on_market_average: {
					2025: '12',
					2024: '17',
					'one-year-change': '-29.4%'
				},
				mls_hpi_benchmark_price: {
					2025: '$544,000',
					2024: '$646,200',
					'one-year-change': '-15.8%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: '38',
					2024: '30',
					'one-year-change': '+26.7%'
				},
				sales: {
					2025: '20',
					2024: '11',
					'one-year-change': '+81.8%'
				},
				days_on_market_average: {
					2025: '33',
					2024: '44',
					'one-year-change': '-25.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$863,200',
					2024: '$1,011,000',
					'one-year-change': '-14.6%'
				}
			}
		},
		'West Vancouver': {
			detached: {
				total_active_listings: {
					2025: 436,
					2024: 417,
					'one-year-change': '+4.6%'
				},
				sales: {
					2025: 29,
					2024: 40,
					'one-year-change': '-27.5%'
				},
				days_on_market_average: {
					2025: 55,
					2024: 47,
					'one-year-change': '+17.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$3,127,700',
					2024: '$3,096,400',
					'one-year-change': '+1.0%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 98,
					2024: 100,
					'one-year-change': '-2.0%'
				},
				sales: {
					2025: 7,
					2024: 12,
					'one-year-change': '-41.7%'
				},
				days_on_market_average: {
					2025: 35,
					2024: 34,
					'one-year-change': '+2.9%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,215,800',
					2024: '$1,371,300',
					'one-year-change': '-11.3%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 28,
					2024: 15,
					'one-year-change': '+86.7%'
				},
				sales: {
					2025: 1,
					2024: 2,
					'one-year-change': '-50.0%'
				},
				days_on_market_average: {
					2025: 1,
					2024: 27,
					'one-year-change': '-96.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$0',
					2024: '$0',
					'one-year-change': '--'
				}
			}
		},
		'Vancouver West': {
			detached: {
				total_active_listings: {
					2025: 646,
					2024: 518,
					'one-year-change': '+24.7%'
				},
				sales: {
					2025: 36,
					2024: 67,
					'one-year-change': '-46.3%'
				},
				days_on_market_average: {
					2025: 47,
					2024: 42,
					'one-year-change': '+11.9%'
				},
				mls_hpi_benchmark_price: {
					2025: '$3,493,200',
					2024: '$3,397,900',
					'one-year-change': '+2.8%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 1738,
					2024: 1425,
					'one-year-change': '+22.0%'
				},
				sales: {
					2025: 236,
					2024: 262,
					'one-year-change': '-9.9%'
				},
				days_on_market_average: {
					2025: 43,
					2024: 43,
					'one-year-change': '0.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$815,700',
					2024: '$839,500',
					'one-year-change': '-2.8%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 253,
					2024: 205,
					'one-year-change': '+23.4%'
				},
				sales: {
					2025: 27,
					2024: 31,
					'one-year-change': '-12.9%'
				},
				days_on_market_average: {
					2025: 28,
					2024: 46,
					'one-year-change': '-39.1%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,414,300',
					2024: '$1,420,500',
					'one-year-change': '-0.4%'
				}
			}
		},
		'BURNABY SOUTH': {
			detached: {
				total_active_listings: {
					2025: 141,
					2024: 98,
					'one-year-change': '+43.9%'
				},
				sales: {
					2025: 11,
					2024: 16,
					'one-year-change': '-31.3%'
				},
				days_on_market_average: {
					2025: 29,
					2024: 25,
					'one-year-change': '+16.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,207,300',
					2024: '$2,184,400',
					'one-year-change': '+1.0%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 392,
					2024: 281,
					'one-year-change': '+39.5%'
				},
				sales: {
					2025: 52,
					2024: 78,
					'one-year-change': '-33.3%'
				},
				days_on_market_average: {
					2025: 43,
					2024: 37,
					'one-year-change': '+16.2%'
				},
				mls_hpi_benchmark_price: {
					2025: '$823,100',
					2024: '$840,500',
					'one-year-change': '-2.1%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 41,
					2024: 37,
					'one-year-change': '+10.8%'
				},
				sales: {
					2025: 9,
					2024: 9,
					'one-year-change': '0.0%'
				},
				days_on_market_average: {
					2025: 47,
					2024: 18,
					'one-year-change': '+161.1%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,108,700',
					2024: '$1,074,100',
					'one-year-change': '+3.2%'
				}
			}
		},
		'port moody': {
			detached: {
				total_active_listings: {
					2025: 98,
					2024: 58,
					'one-year-change': '+69.0%'
				},
				sales: {
					2025: 10,
					2024: 7,
					'one-year-change': '+42.9%'
				},
				days_on_market_average: {
					2025: 36,
					2024: 24,
					'one-year-change': '+50.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,089,700',
					2024: '$2,028,100',
					'one-year-change': '+3.0%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 92,
					2024: 45,
					'one-year-change': '+104.4%'
				},
				sales: {
					2025: 19,
					2024: 31,
					'one-year-change': '-38.7%'
				},
				days_on_market_average: {
					2025: 35,
					2024: 25,
					'one-year-change': '+40.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$718,000',
					2024: '$724,600',
					'one-year-change': '-0.9%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 30,
					2024: 21,
					'one-year-change': '+42.9%'
				},
				sales: {
					2025: 9,
					2024: 8,
					'one-year-change': '+12.5%'
				},
				days_on_market_average: {
					2025: 31,
					2024: 17,
					'one-year-change': '+82.4%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,011,300',
					2024: '$1,025,900',
					'one-year-change': '-1.4%'
				}
			}
		},
		'BURNANBY EAST': {
			detached: {
				total_active_listings: {
					2025: 36,
					2024: 33,
					'one-year-change': '+9.1%'
				},
				sales: {
					2025: 6,
					2024: 8,
					'one-year-change': '-25.0%'
				},
				days_on_market_average: {
					2025: 12,
					2024: 30,
					'one-year-change': '-60.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,959,700',
					2024: '$1,907,600',
					'one-year-change': '+2.7%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 78,
					2024: 54,
					'one-year-change': '+44.4%'
				},
				sales: {
					2025: 9,
					2024: 13,
					'one-year-change': '-30.8%'
				},
				days_on_market_average: {
					2025: 36,
					2024: 48,
					'one-year-change': '-25.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$784,900',
					2024: '$789,600',
					'one-year-change': '-0.6%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 23,
					2024: 10,
					'one-year-change': '+130.0%'
				},
				sales: {
					2025: 5,
					2024: 3,
					'one-year-change': '+66.7%'
				},
				days_on_market_average: {
					2025: 56,
					2024: 6,
					'one-year-change': '+833.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$915,800',
					2024: '$890,500',
					'one-year-change': '+2.8%'
				}
			}
		},
		'Vancouver East': {
			detached: {
				total_active_listings: {
					2025: 537,
					2024: 410,
					'one-year-change': '+31.0%'
				},
				sales: {
					2025: 55,
					2024: 64,
					'one-year-change': '-14.1%'
				},
				days_on_market_average: {
					2025: 40,
					2024: 35,
					'one-year-change': '+14.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,862,500',
					2024: '$1,833,000',
					'one-year-change': '+1.6%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 457,
					2024: 417,
					'one-year-change': '+9.6%'
				},
				sales: {
					2025: 92,
					2024: 117,
					'one-year-change': '-21.4%'
				},
				days_on_market_average: {
					2025: 25,
					2024: 29,
					'one-year-change': '-13.8%'
				},
				mls_hpi_benchmark_price: {
					2025: '$684,800',
					2024: '$707,700',
					'one-year-change': '-3.2%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 98,
					2024: 100,
					'one-year-change': '-2.0%'
				},
				sales: {
					2025: 26,
					2024: 21,
					'one-year-change': '+23.8%'
				},
				days_on_market_average: {
					2025: 17,
					2024: 23,
					'one-year-change': '-26.1%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,169,800',
					2024: '$1,109,700',
					'one-year-change': '+5.4%'
				}
			}
		},
		'Maple Ridge': {
			detached: {
				total_active_listings: {
					2025: 471,
					2024: 426,
					'one-year-change': '+10.6%'
				},
				sales: {
					2025: 55,
					2024: 69,
					'one-year-change': '-20.3%'
				},
				days_on_market_average: {
					2025: 39,
					2024: 39,
					'one-year-change': '0.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,250,400',
					2024: '$1,269,800',
					'one-year-change': '-1.5%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 142,
					2024: 184,
					'one-year-change': '-22.8%'
				},
				sales: {
					2025: 35,
					2024: 31,
					'one-year-change': '+12.9%'
				},
				days_on_market_average: {
					2025: 30,
					2024: 26,
					'one-year-change': '+15.4%'
				},
				mls_hpi_benchmark_price: {
					2025: '$522,500',
					2024: '$531,000',
					'one-year-change': '-1.6%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 96,
					2024: 90,
					'one-year-change': '+6.7%'
				},
				sales: {
					2025: 38,
					2024: 43,
					'one-year-change': '-11.6%'
				},
				days_on_market_average: {
					2025: 36,
					2024: 34,
					'one-year-change': '+5.9%'
				},
				mls_hpi_benchmark_price: {
					2025: '$771,100',
					2024: '$771,500',
					'one-year-change': '-0.1%'
				}
			}
		},
		'Metro Vancouver': {
			detached: {
				total_active_listings: {
					2025: '4,692',
					2024: '3,841',
					'one-year-change': '+22.2%'
				},
				sales: {
					2025: '478',
					2024: '561',
					'one-year-change': '-14.8%'
				},
				days_on_market_average: {
					2025: '45',
					2024: '47',
					'one-year-change': '-4.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,006,100',
					2024: '$1,970,700',
					'one-year-change': '+1.8%'
				}
			},
			condo: {
				total_active_listings: {
					2025: '5,750',
					2024: '4,315',
					'one-year-change': '+33.3%'
				},
				sales: {
					2025: '977',
					2024: '1,093',
					'one-year-change': '-10.6%'
				},
				days_on_market_average: {
					2025: '37',
					2024: '34',
					'one-year-change': '+8.8%'
				},
				mls_hpi_benchmark_price: {
					2025: '$747,500',
					2024: '$768,800',
					'one-year-change': '-2.8%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: '1,425',
					2024: '1,085',
					'one-year-change': '+31.3%'
				},
				sales: {
					2025: '291',
					2024: '316',
					'one-year-change': '-7.9%'
				},
				days_on_market_average: {
					2025: '33',
					2024: '32',
					'one-year-change': '+3.1%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,087,100',
					2024: '$1,100,600',
					'one-year-change': '-1.2%'
				}
			}
		},
		'New Westminster': {
			detached: {
				total_active_listings: {
					2025: '100',
					2024: '82',
					'one-year-change': '+22.0%'
				},
				sales: {
					2025: '11',
					2024: '10',
					'one-year-change': '+10.0%'
				},
				days_on_market_average: {
					2025: '42',
					2024: '42',
					'one-year-change': '0.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,574,200',
					2024: '$1,561,200',
					'one-year-change': '+0.8%'
				}
			},
			condo: {
				total_active_listings: {
					2025: '299',
					2024: '177',
					'one-year-change': '+68.9%'
				},
				sales: {
					2025: '69',
					2024: '63',
					'one-year-change': '+9.5%'
				},
				days_on_market_average: {
					2025: '32',
					2024: '29',
					'one-year-change': '+10.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$657,600',
					2024: '$653,600',
					'one-year-change': '+0.6%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: '28',
					2024: '34',
					'one-year-change': '-17.6%'
				},
				sales: {
					2025: '8',
					2024: '5',
					'one-year-change': '+60.0%'
				},
				days_on_market_average: {
					2025: '52',
					2024: '13',
					'one-year-change': '+300.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$950,700',
					2024: '$935,500',
					'one-year-change': '+1.6%'
				}
			}
		},
		'port coquitlam': {
			detached: {
				total_active_listings: {
					2025: 134,
					2024: 101,
					'one-year-change': '+32.7%'
				},
				sales: {
					2025: 18,
					2024: 15,
					'one-year-change': '+20.0%'
				},
				days_on_market_average: {
					2025: 28,
					2024: 26,
					'one-year-change': '+7.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,409,400',
					2024: '$1,376,200',
					'one-year-change': '+2.4%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 81,
					2024: 71,
					'one-year-change': '+14.1%'
				},
				sales: {
					2025: 28,
					2024: 32,
					'one-year-change': '-12.5%'
				},
				days_on_market_average: {
					2025: 24,
					2024: 27,
					'one-year-change': '-11.1%'
				},
				mls_hpi_benchmark_price: {
					2025: '$630,700',
					2024: '$643,500',
					'one-year-change': '-2.0%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 39,
					2024: 25,
					'one-year-change': '+56.0%'
				},
				sales: {
					2025: 9,
					2024: 16,
					'one-year-change': '-43.8%'
				},
				days_on_market_average: {
					2025: 20,
					2024: 20,
					'one-year-change': '0.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$956,300',
					2024: '$938,500',
					'one-year-change': '+1.9%'
				}
			}
		},
		'north vancover': {
			detached: {
				total_active_listings: {
					2025: 229,
					2024: 201,
					'one-year-change': '+13.9%'
				},
				sales: {
					2025: 48,
					2024: 42,
					'one-year-change': '+14.3%'
				},
				days_on_market_average: {
					2025: 35,
					2024: 20,
					'one-year-change': '+75.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,232,600',
					2024: '$2,185,400',
					'one-year-change': '+2.2%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 311,
					2024: 233,
					'one-year-change': '+33.5%'
				},
				sales: {
					2025: 78,
					2024: 91,
					'one-year-change': '-14.3%'
				},
				days_on_market_average: {
					2025: 28,
					2024: 14,
					'one-year-change': '+100.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$804,100',
					2024: '$810,500',
					'one-year-change': '-0.8%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 104,
					2024: 75,
					'one-year-change': '+38.7%'
				},
				sales: {
					2025: 21,
					2024: 26,
					'one-year-change': '-19.2%'
				},
				days_on_market_average: {
					2025: 16,
					2024: 25,
					'one-year-change': '-36.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,366,100',
					2024: '$1,336,700',
					'one-year-change': '+2.2%'
				}
			}
		},
		Ladner: {
			detached: {
				total_active_listings: {
					2025: 79,
					2024: 65,
					'one-year-change': '+21.5%'
				},
				sales: {
					2025: 11,
					2024: 10,
					'one-year-change': '+10.0%'
				},
				days_on_market_average: {
					2025: 38,
					2024: 79,
					'one-year-change': '-51.9%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,398,600',
					2024: '$1,356,700',
					'one-year-change': '+3.1%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 22,
					2024: 4,
					'one-year-change': '+450.0%'
				},
				sales: {
					2025: 7,
					2024: 8,
					'one-year-change': '-12.5%'
				},
				days_on_market_average: {
					2025: 37,
					2024: 18,
					'one-year-change': '+105.6%'
				},
				mls_hpi_benchmark_price: {
					2025: '$624,500',
					2024: '$699,400',
					'one-year-change': '-10.7%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 34,
					2024: 14,
					'one-year-change': '+142.9%'
				},
				sales: {
					2025: 11,
					2024: 5,
					'one-year-change': '+120.0%'
				},
				days_on_market_average: {
					2025: 22,
					2024: 21,
					'one-year-change': '+4.8%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,041,400',
					2024: '$996,600',
					'one-year-change': '+4.5%'
				}
			}
		},
		richmond: {
			detached: {
				total_active_listings: {
					2025: '497',
					2024: '437',
					'one-year-change': '+13.7%'
				},
				sales: {
					2025: '40',
					2024: '69',
					'one-year-change': '-42.0%'
				},
				days_on_market_average: {
					2025: '27',
					2024: '56',
					'one-year-change': '-51.8%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,139,000',
					2024: '$2,177,000',
					'one-year-change': '-1.7%'
				}
			},
			condo: {
				total_active_listings: {
					2025: '731',
					2024: '504',
					'one-year-change': '+45.0%'
				},
				sales: {
					2025: '98',
					2024: '107',
					'one-year-change': '-8.4%'
				},
				days_on_market_average: {
					2025: '42',
					2024: '36',
					'one-year-change': '+16.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$733,800',
					2024: '$750,400',
					'one-year-change': '-2.2%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: '266',
					2024: '150',
					'one-year-change': '+77.3%'
				},
				sales: {
					2025: '39',
					2024: '55',
					'one-year-change': '-29.1%'
				},
				days_on_market_average: {
					2025: '39',
					2024: '45',
					'one-year-change': '-13.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,109,300',
					2024: '$1,138,300',
					'one-year-change': '-2.5%'
				}
			}
		},
		'pitt meadows': {
			detached: {
				total_active_listings: {
					2025: 53,
					2024: 46,
					'one-year-change': '+15.2%'
				},
				sales: {
					2025: 8,
					2024: 10,
					'one-year-change': '-20.0%'
				},
				days_on_market_average: {
					2025: 14,
					2024: 39,
					'one-year-change': '-64.1%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,179,600',
					2024: '$1,322,100',
					'one-year-change': '-10.8%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 19,
					2024: 11,
					'one-year-change': '+72.7%'
				},
				sales: {
					2025: 8,
					2024: 7,
					'one-year-change': '+14.3%'
				},
				days_on_market_average: {
					2025: 75,
					2024: 24,
					'one-year-change': '+212.5%'
				},
				mls_hpi_benchmark_price: {
					2025: '$599,800',
					2024: '$605,000',
					'one-year-change': '-0.9%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 17,
					2024: 14,
					'one-year-change': '+21.4%'
				},
				sales: {
					2025: 5,
					2024: 4,
					'one-year-change': '+25.0%'
				},
				days_on_market_average: {
					2025: 51,
					2024: 12,
					'one-year-change': '+325.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$836,400',
					2024: '$828,300',
					'one-year-change': '+1.0%'
				}
			}
		},
		'Burnaby East': {
			detached: {
				total_active_listings: {
					2025: 36,
					2024: 33,
					'one-year-change': '+9.1%'
				},
				sales: {
					2025: 6,
					2024: 8,
					'one-year-change': '-25.0%'
				},
				days_on_market_average: {
					2025: 12,
					2024: 30,
					'one-year-change': '-60.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,959,700',
					2024: '$1,907,600',
					'one-year-change': '+2.7%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 78,
					2024: 54,
					'one-year-change': '+44.4%'
				},
				sales: {
					2025: 9,
					2024: 13,
					'one-year-change': '-30.8%'
				},
				days_on_market_average: {
					2025: 36,
					2024: 48,
					'one-year-change': '-25.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$784,900',
					2024: '$789,600',
					'one-year-change': '-0.6%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 23,
					2024: 10,
					'one-year-change': '+130.0%'
				},
				sales: {
					2025: 5,
					2024: 3,
					'one-year-change': '+66.7%'
				},
				days_on_market_average: {
					2025: 56,
					2024: 6,
					'one-year-change': '+833.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$915,800',
					2024: '$890,500',
					'one-year-change': '+2.8%'
				}
			}
		},
		COQUITLAM: {
			detached: {
				total_active_listings: {
					2025: '394',
					2024: '232',
					'one-year-change': '+69.8%'
				},
				sales: {
					2025: '40',
					2024: '45',
					'one-year-change': '-11.1%'
				},
				days_on_market_average: {
					2025: '33',
					2024: '50',
					'one-year-change': '-34.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,796,600',
					2024: '$1,799,500',
					'one-year-change': '-0.2%'
				}
			},
			condo: {
				total_active_listings: {
					2025: '470',
					2024: '264',
					'one-year-change': '+78.0%'
				},
				sales: {
					2025: '88',
					2024: '104',
					'one-year-change': '-15.4%'
				},
				days_on_market_average: {
					2025: '32',
					2024: '35',
					'one-year-change': '-8.6%'
				},
				mls_hpi_benchmark_price: {
					2025: '$732,000',
					2024: '$742,200',
					'one-year-change': '-1.4%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: '145',
					2024: '108',
					'one-year-change': '+34.3%'
				},
				sales: {
					2025: '31',
					2024: '37',
					'one-year-change': '-16.2%'
				},
				days_on_market_average: {
					2025: '34',
					2024: '23',
					'one-year-change': '+47.8%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,056,100',
					2024: '$1,055,200',
					'one-year-change': '+0.1%'
				}
			}
		}
	},
	'March 2025': {
		Tsawwassen: {
			detached: {
				total_active_listings: {
					2025: 138,
					2024: 81,
					'one-year-change': '+70.4%'
				},
				sales: {
					2025: 19,
					2024: 16,
					'one-year-change': '+18.8%'
				},
				days_on_market_average: {
					2025: 23,
					2024: 32,
					'one-year-change': '-28.1%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,649,800',
					2024: '$1,686,000',
					'one-year-change': '-2.1%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 81,
					2024: 52,
					'one-year-change': '+55.8%'
				},
				sales: {
					2025: 13,
					2024: 11,
					'one-year-change': '+18.2%'
				},
				days_on_market_average: {
					2025: 29,
					2024: 30,
					'one-year-change': '-3.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$676,800',
					2024: '$679,000',
					'one-year-change': '-0.3%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 42,
					2024: 23,
					'one-year-change': '+82.6%'
				},
				sales: {
					2025: 4,
					2024: 4,
					'one-year-change': '0.0%'
				},
				days_on_market_average: {
					2025: 63,
					2024: 14,
					'one-year-change': '+350.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$971,700',
					2024: '$1,016,500',
					'one-year-change': '-4.4%'
				}
			}
		},
		'Burnaby south': {
			detached: {
				total_active_listings: {
					2025: 161,
					2024: 98,
					'one-year-change': '+64.3%'
				},
				sales: {
					2025: 16,
					2024: 26,
					'one-year-change': '-38.5%'
				},
				days_on_market_average: {
					2025: 33,
					2024: 20,
					'one-year-change': '+65.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,238,900',
					2024: '$2,219,300',
					'one-year-change': '+0.9%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 412,
					2024: 300,
					'one-year-change': '+37.3%'
				},
				sales: {
					2025: 54,
					2024: 101,
					'one-year-change': '-46.5%'
				},
				days_on_market_average: {
					2025: 42,
					2024: 27,
					'one-year-change': '+55.6%'
				},
				mls_hpi_benchmark_price: {
					2025: '$837,500',
					2024: '$845,000',
					'one-year-change': '-0.9%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 46,
					2024: 40,
					'one-year-change': '+15.0%'
				},
				sales: {
					2025: 18,
					2024: 10,
					'one-year-change': '+80.0%'
				},
				days_on_market_average: {
					2025: 13,
					2024: 31,
					'one-year-change': '-58.1%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,052,000',
					2024: '$1,088,300',
					'one-year-change': '-3.3%'
				}
			}
		},
		'Port Moody': {
			detached: {
				total_active_listings: {
					2025: 98,
					2024: 66,
					'one-year-change': '+48.5%'
				},
				sales: {
					2025: 13,
					2024: 11,
					'one-year-change': '+18.2%'
				},
				days_on_market_average: {
					2025: 31,
					2024: 28,
					'one-year-change': '+10.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,111,300',
					2024: '$2,104,600',
					'one-year-change': '+0.3%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 116,
					2024: 59,
					'one-year-change': '+96.6%'
				},
				sales: {
					2025: 28,
					2024: 20,
					'one-year-change': '+40.0%'
				},
				days_on_market_average: {
					2025: 15,
					2024: 15,
					'one-year-change': '0.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$738,200',
					2024: '$737,300',
					'one-year-change': '+0.1%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 41,
					2024: 24,
					'one-year-change': '+70.8%'
				},
				sales: {
					2025: 10,
					2024: 12,
					'one-year-change': '-16.7%'
				},
				days_on_market_average: {
					2025: 13,
					2024: 11,
					'one-year-change': '+18.2%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,034,600',
					2024: '$1,027,800',
					'one-year-change': '+0.7%'
				}
			}
		},
		Squamish: {
			detached: {
				total_active_listings: {
					2025: '76',
					2024: '80',
					'one-year-change': '-5.0%'
				},
				sales: {
					2025: '13',
					2024: '11',
					'one-year-change': '+18.2%'
				},
				days_on_market_average: {
					2025: '12',
					2024: '64',
					'one-year-change': '-81.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,649,400',
					2024: '$1,517,600',
					'one-year-change': '+8.7%'
				}
			},
			condo: {
				total_active_listings: {
					2025: '78',
					2024: '50',
					'one-year-change': '+56.0%'
				},
				sales: {
					2025: '12',
					2024: '7',
					'one-year-change': '+71.4%'
				},
				days_on_market_average: {
					2025: '19',
					2024: '25',
					'one-year-change': '-24.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$604,700',
					2024: '$639,000',
					'one-year-change': '-5.4%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: '34',
					2024: '31',
					'one-year-change': '+9.7%'
				},
				sales: {
					2025: '13',
					2024: '13',
					'one-year-change': '0.0%'
				},
				days_on_market_average: {
					2025: '25',
					2024: '37',
					'one-year-change': '-32.4%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,049,900',
					2024: '$1,044,900',
					'one-year-change': '+0.5%'
				}
			}
		},
		Whistler: {
			detached: {
				total_active_listings: {
					2025: 93,
					2024: 80,
					'one-year-change': '+16.3%'
				},
				sales: {
					2025: 4,
					2024: 4,
					'one-year-change': '0.0%'
				},
				days_on_market_average: {
					2025: 20,
					2024: 157,
					'one-year-change': '-87.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,549,100',
					2024: '$2,396,200',
					'one-year-change': '+6.4%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 124,
					2024: 104,
					'one-year-change': '+19.2%'
				},
				sales: {
					2025: 16,
					2024: 22,
					'one-year-change': '-27.3%'
				},
				days_on_market_average: {
					2025: 27,
					2024: 27,
					'one-year-change': '0.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$651,100',
					2024: '$727,700',
					'one-year-change': '-10.5%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 88,
					2024: 75,
					'one-year-change': '+17.3%'
				},
				sales: {
					2025: 10,
					2024: 13,
					'one-year-change': '-23.1%'
				},
				days_on_market_average: {
					2025: 53,
					2024: 26,
					'one-year-change': '+103.8%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,674,500',
					2024: '$1,711,400',
					'one-year-change': '-2.2%'
				}
			}
		},
		'Burnaby North': {
			detached: {
				total_active_listings: {
					2025: 169,
					2024: 86,
					'one-year-change': '+96.5%'
				},
				sales: {
					2025: 12,
					2024: 25,
					'one-year-change': '-52.0%'
				},
				days_on_market_average: {
					2025: 10,
					2024: 28,
					'one-year-change': '-64.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,163,600',
					2024: '$2,089,100',
					'one-year-change': '+3.6%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 621,
					2024: 409,
					'one-year-change': '+51.8%'
				},
				sales: {
					2025: 77,
					2024: 68,
					'one-year-change': '+13.2%'
				},
				days_on_market_average: {
					2025: 32,
					2024: 22,
					'one-year-change': '+45.5%'
				},
				mls_hpi_benchmark_price: {
					2025: '$757,200',
					2024: '$770,700',
					'one-year-change': '-1.8%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 51,
					2024: 36,
					'one-year-change': '+41.7%'
				},
				sales: {
					2025: 16,
					2024: 14,
					'one-year-change': '+14.3%'
				},
				days_on_market_average: {
					2025: 38,
					2024: 14,
					'one-year-change': '+171.4%'
				},
				mls_hpi_benchmark_price: {
					2025: '$904,800',
					2024: '$919,600',
					'one-year-change': '-1.6%'
				}
			}
		},
		'Vancouver East': {
			detached: {
				total_active_listings: {
					2025: '607',
					2024: '436',
					'one-year-change': '+39.2%'
				},
				sales: {
					2025: '69',
					2024: '78',
					'one-year-change': '-11.5%'
				},
				days_on_market_average: {
					2025: '37',
					2024: '28',
					'one-year-change': '+32.1%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,854,600',
					2024: '$1,855,300',
					'one-year-change': '-0.0%'
				}
			},
			condo: {
				total_active_listings: {
					2025: '550',
					2024: '465',
					'one-year-change': '+18.3%'
				},
				sales: {
					2025: '105',
					2024: '126',
					'one-year-change': '-16.7%'
				},
				days_on_market_average: {
					2025: '24',
					2024: '20',
					'one-year-change': '+20.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$702,800',
					2024: '$711,800',
					'one-year-change': '-1.3%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: '113',
					2024: '106',
					'one-year-change': '+6.6%'
				},
				sales: {
					2025: '28',
					2024: '27',
					'one-year-change': '+3.7%'
				},
				days_on_market_average: {
					2025: '31',
					2024: '17',
					'one-year-change': '+82.4%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,159,400',
					2024: '$1,136,800',
					'one-year-change': '+2.0%'
				}
			}
		},
		'Maple Ridge': {
			detached: {
				total_active_listings: {
					2025: 535,
					2024: 420,
					'one-year-change': '+27.4%'
				},
				sales: {
					2025: 50,
					2024: 100,
					'one-year-change': '-50.0%'
				},
				days_on_market_average: {
					2025: 33,
					2024: 24,
					'one-year-change': '+37.5%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,287,800',
					2024: '$1,287,000',
					'one-year-change': '+0.1%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 146,
					2024: 213,
					'one-year-change': '-31.5%'
				},
				sales: {
					2025: 23,
					2024: 31,
					'one-year-change': '-25.8%'
				},
				days_on_market_average: {
					2025: 32,
					2024: 33,
					'one-year-change': '-3.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$519,200',
					2024: '$535,600',
					'one-year-change': '-3.1%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 103,
					2024: 96,
					'one-year-change': '+7.3%'
				},
				sales: {
					2025: 33,
					2024: 52,
					'one-year-change': '-36.5%'
				},
				days_on_market_average: {
					2025: 27,
					2024: 17,
					'one-year-change': '+58.8%'
				},
				mls_hpi_benchmark_price: {
					2025: '$793,500',
					2024: '$784,400',
					'one-year-change': '+1.2%'
				}
			}
		},
		'Metro Vancouver': {
			detached: {
				total_active_listings: {
					2025: '5,256',
					2024: '4,066',
					'one-year-change': '+29.3%'
				},
				sales: {
					2025: '528',
					2024: '694',
					'one-year-change': '-23.9%'
				},
				days_on_market_average: {
					2025: '35',
					2024: '35',
					'one-year-change': '0.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,034,400',
					2024: '$2,018,000',
					'one-year-change': '+0.8%'
				}
			},
			condo: {
				total_active_listings: {
					2025: '6,580',
					2024: '4,782',
					'one-year-change': '+37.6%'
				},
				sales: {
					2025: '1,067',
					2024: '1,207',
					'one-year-change': '-9.9%'
				},
				days_on_market_average: {
					2025: '28',
					2024: '26',
					'one-year-change': '+7.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$767,300',
					2024: '$774,500',
					'one-year-change': '-0.9%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: '1,631',
					2024: '1,176',
					'one-year-change': '+38.7%'
				},
				sales: {
					2025: '370',
					2024: '398',
					'one-year-change': '-7.0%'
				},
				days_on_market_average: {
					2025: '27',
					2024: '20',
					'one-year-change': '+35.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,113,100',
					2024: '$1,122,000',
					'one-year-change': '-0.8%'
				}
			}
		},
		'West Vancouver': {
			detached: {
				total_active_listings: {
					2025: 461,
					2024: 421,
					'one-year-change': '+9.5%'
				},
				sales: {
					2025: 28,
					2024: 38,
					'one-year-change': '-26.3%'
				},
				days_on_market_average: {
					2025: 35,
					2024: 61,
					'one-year-change': '-42.6%'
				},
				mls_hpi_benchmark_price: {
					2025: '$3,275,300',
					2024: '$3,262,800',
					'one-year-change': '+0.4%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 106,
					2024: 104,
					'one-year-change': '+1.9%'
				},
				sales: {
					2025: 9,
					2024: 14,
					'one-year-change': '-35.7%'
				},
				days_on_market_average: {
					2025: 29,
					2024: 22,
					'one-year-change': '+31.8%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,266,800',
					2024: '$1,315,900',
					'one-year-change': '-5.9%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 30,
					2024: 18,
					'one-year-change': '+66.7%'
				},
				sales: {
					2025: 1,
					2024: 1,
					'one-year-change': '0.0%'
				},
				days_on_market_average: {
					2025: 7,
					2024: 25,
					'one-year-change': '-72.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$0',
					2024: '$0',
					'one-year-change': '--'
				}
			}
		},
		'New Westminster': {
			detached: {
				total_active_listings: {
					2025: 117,
					2024: 103,
					'one-year-change': '+13.6%'
				},
				sales: {
					2025: 6,
					2024: 24,
					'one-year-change': '-75.0%'
				},
				days_on_market_average: {
					2025: 53,
					2024: 26,
					'one-year-change': '+103.8%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,608,400',
					2024: '$1,597,400',
					'one-year-change': '+0.7%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 336,
					2024: 200,
					'one-year-change': '+68.0%'
				},
				sales: {
					2025: 86,
					2024: 73,
					'one-year-change': '+17.8%'
				},
				days_on_market_average: {
					2025: 27,
					2024: 21,
					'one-year-change': '+28.6%'
				},
				mls_hpi_benchmark_price: {
					2025: '$652,300',
					2024: '$660,200',
					'one-year-change': '-1.2%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 44,
					2024: 38,
					'one-year-change': '+15.8%'
				},
				sales: {
					2025: 10,
					2024: 10,
					'one-year-change': '0.0%'
				},
				days_on_market_average: {
					2025: 26,
					2024: 9,
					'one-year-change': '+188.9%'
				},
				mls_hpi_benchmark_price: {
					2025: '$923,100',
					2024: '$952,400',
					'one-year-change': '-3.1%'
				}
			}
		},
		'Port coquitlam': {
			detached: {
				total_active_listings: {
					2025: 153,
					2024: 105,
					'one-year-change': '+45.7%'
				},
				sales: {
					2025: 19,
					2024: 26,
					'one-year-change': '-26.9%'
				},
				days_on_market_average: {
					2025: 33,
					2024: 25,
					'one-year-change': '+32.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,418,500',
					2024: '$1,407,200',
					'one-year-change': '+0.8%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 97,
					2024: 70,
					'one-year-change': '+38.6%'
				},
				sales: {
					2025: 28,
					2024: 44,
					'one-year-change': '-36.4%'
				},
				days_on_market_average: {
					2025: 17,
					2024: 19,
					'one-year-change': '-10.5%'
				},
				mls_hpi_benchmark_price: {
					2025: '$641,800',
					2024: '$641,300',
					'one-year-change': '+0.1%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 53,
					2024: 27,
					'one-year-change': '+96.3%'
				},
				sales: {
					2025: 14,
					2024: 19,
					'one-year-change': '-26.3%'
				},
				days_on_market_average: {
					2025: 12,
					2024: 21,
					'one-year-change': '-42.9%'
				},
				mls_hpi_benchmark_price: {
					2025: '$950,700',
					2024: '$950,800',
					'one-year-change': '-0.0%'
				}
			}
		},
		'Sunshine Coast': {
			detached: {
				total_active_listings: {
					2025: 368,
					2024: 347,
					'one-year-change': '+6.1%'
				},
				sales: {
					2025: 31,
					2024: 35,
					'one-year-change': '-11.4%'
				},
				days_on_market_average: {
					2025: 67,
					2024: 73,
					'one-year-change': '-8.2%'
				},
				mls_hpi_benchmark_price: {
					2025: '$873,600',
					2024: '$878,700',
					'one-year-change': '-0.6%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 48,
					2024: 28,
					'one-year-change': '+71.4%'
				},
				sales: {
					2025: 2,
					2024: 4,
					'one-year-change': '-50.0%'
				},
				days_on_market_average: {
					2025: 32,
					2024: 61,
					'one-year-change': '-47.5%'
				},
				mls_hpi_benchmark_price: {
					2025: '$493,800',
					2024: '$545,800',
					'one-year-change': '-9.5%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 29,
					2024: 26,
					'one-year-change': '+11.5%'
				},
				sales: {
					2025: 3,
					2024: 3,
					'one-year-change': '0.0%'
				},
				days_on_market_average: {
					2025: 86,
					2024: 12,
					'one-year-change': '+616.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$766,700',
					2024: '$761,900',
					'one-year-change': '+0.6%'
				}
			}
		},
		Ladner: {
			detached: {
				total_active_listings: {
					2025: 87,
					2024: 67,
					'one-year-change': '+29.9%'
				},
				sales: {
					2025: 14,
					2024: 15,
					'one-year-change': '-6.7%'
				},
				days_on_market_average: {
					2025: 20,
					2024: 30,
					'one-year-change': '-33.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,422,000',
					2024: '$1,415,500',
					'one-year-change': '+0.5%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 18,
					2024: 9,
					'one-year-change': '+100.0%'
				},
				sales: {
					2025: 8,
					2024: 2,
					'one-year-change': '+300.0%'
				},
				days_on_market_average: {
					2025: 32,
					2024: 16,
					'one-year-change': '+100.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$693,200',
					2024: '$679,500',
					'one-year-change': '+2.0%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 39,
					2024: 16,
					'one-year-change': '+143.8%'
				},
				sales: {
					2025: 8,
					2024: 12,
					'one-year-change': '-33.3%'
				},
				days_on_market_average: {
					2025: 33,
					2024: 12,
					'one-year-change': '+175.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,022,500',
					2024: '$1,017,400',
					'one-year-change': '+0.5%'
				}
			}
		},
		Richmond: {
			detached: {
				total_active_listings: {
					2025: 546,
					2024: 455,
					'one-year-change': '+20.0%'
				},
				sales: {
					2025: 47,
					2024: 77,
					'one-year-change': '-39.0%'
				},
				days_on_market_average: {
					2025: 38,
					2024: 43,
					'one-year-change': '-11.6%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,171,100',
					2024: '$2,217,900',
					'one-year-change': '-2.1%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 856,
					2024: 558,
					'one-year-change': '+53.4%'
				},
				sales: {
					2025: 122,
					2024: 142,
					'one-year-change': '-14.1%'
				},
				days_on_market_average: {
					2025: 28,
					2024: 31,
					'one-year-change': '-9.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$745,400',
					2024: '$759,600',
					'one-year-change': '-1.9%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 286,
					2024: 162,
					'one-year-change': '+76.5%'
				},
				sales: {
					2025: 49,
					2024: 57,
					'one-year-change': '-14.0%'
				},
				days_on_market_average: {
					2025: 28,
					2024: 30,
					'one-year-change': '-6.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,124,100',
					2024: '$1,151,200',
					'one-year-change': '-2.4%'
				}
			}
		},
		'Bowen Island': {
			detached: {
				total_active_listings: {
					2025: 44,
					2024: 37,
					'one-year-change': '+18.9%'
				},
				sales: {
					2025: 3,
					2024: 4,
					'one-year-change': '-25.0%'
				},
				days_on_market_average: {
					2025: 97,
					2024: 118,
					'one-year-change': '-17.8%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,386,300',
					2024: '$1,351,900',
					'one-year-change': '+2.5%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 0,
					2024: 0,
					'one-year-change': '--'
				},
				sales: {
					2025: 0,
					2024: 0,
					'one-year-change': '--'
				},
				days_on_market_average: {
					2025: 0,
					2024: 0,
					'one-year-change': '--'
				},
				mls_hpi_benchmark_price: {
					2025: '$0',
					2024: '$0',
					'one-year-change': '--'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 0,
					2024: 0,
					'one-year-change': '--'
				},
				sales: {
					2025: 0,
					2024: 0,
					'one-year-change': '--'
				},
				days_on_market_average: {
					2025: 0,
					2024: 0,
					'one-year-change': '--'
				},
				mls_hpi_benchmark_price: {
					2025: '$0',
					2024: '$0',
					'one-year-change': '--'
				}
			}
		},
		'Pitt meadows': {
			detached: {
				total_active_listings: {
					2025: 56,
					2024: 41,
					'one-year-change': '+36.6%'
				},
				sales: {
					2025: 11,
					2024: 15,
					'one-year-change': '-26.7%'
				},
				days_on_market_average: {
					2025: 42,
					2024: 35,
					'one-year-change': '+20.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,324,600',
					2024: '$1,338,800',
					'one-year-change': '-1.1%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 28,
					2024: 12,
					'one-year-change': '+133.3%'
				},
				sales: {
					2025: 4,
					2024: 5,
					'one-year-change': '-20.0%'
				},
				days_on_market_average: {
					2025: 13,
					2024: 9,
					'one-year-change': '+44.4%'
				},
				mls_hpi_benchmark_price: {
					2025: '$593,100',
					2024: '$609,600',
					'one-year-change': '-2.7%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 22,
					2024: 16,
					'one-year-change': '+37.5%'
				},
				sales: {
					2025: 12,
					2024: 8,
					'one-year-change': '+50.0%'
				},
				days_on_market_average: {
					2025: 20,
					2024: 8,
					'one-year-change': '+150.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$853,500',
					2024: '$847,200',
					'one-year-change': '+0.7%'
				}
			}
		},
		'Burnaby East': {
			detached: {
				total_active_listings: {
					2025: 40,
					2024: 35,
					'one-year-change': '+14.3%'
				},
				sales: {
					2025: 6,
					2024: 6,
					'one-year-change': '0.0%'
				},
				days_on_market_average: {
					2025: 13,
					2024: 28,
					'one-year-change': '-53.6%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,994,800',
					2024: '$1,951,700',
					'one-year-change': '+2.2%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 87,
					2024: 52,
					'one-year-change': '+67.3%'
				},
				sales: {
					2025: 14,
					2024: 23,
					'one-year-change': '-39.1%'
				},
				days_on_market_average: {
					2025: 31,
					2024: 19,
					'one-year-change': '+63.2%'
				},
				mls_hpi_benchmark_price: {
					2025: '$784,200',
					2024: '$805,600',
					'one-year-change': '-2.7%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 27,
					2024: 17,
					'one-year-change': '+58.8%'
				},
				sales: {
					2025: 6,
					2024: 2,
					'one-year-change': '+200.0%'
				},
				days_on_market_average: {
					2025: 21,
					2024: 7,
					'one-year-change': '+200.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$906,500',
					2024: '$917,600',
					'one-year-change': '-1.2%'
				}
			}
		},
		Coquitlam: {
			detached: {
				total_active_listings: {
					2025: 450,
					2024: 251,
					'one-year-change': '+79.3%'
				},
				sales: {
					2025: 49,
					2024: 58,
					'one-year-change': '-15.5%'
				},
				days_on_market_average: {
					2025: 20,
					2024: 23,
					'one-year-change': '-13.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,814,200',
					2024: '$1,827,300',
					'one-year-change': '-0.7%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 517,
					2024: 300,
					'one-year-change': '+72.3%'
				},
				sales: {
					2025: 114,
					2024: 113,
					'one-year-change': '+0.9%'
				},
				days_on_market_average: {
					2025: 25,
					2024: 23,
					'one-year-change': '+8.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$734,400',
					2024: '$755,100',
					'one-year-change': '-2.7%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 163,
					2024: 103,
					'one-year-change': '+58.3%'
				},
				sales: {
					2025: 63,
					2024: 60,
					'one-year-change': '+5.0%'
				},
				days_on_market_average: {
					2025: 19,
					2024: 14,
					'one-year-change': '+35.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,083,400',
					2024: '$1,067,500',
					'one-year-change': '+1.5%'
				}
			}
		},
		'North Vancouver': {
			detached: {
				total_active_listings: {
					2025: 276,
					2024: 203,
					'one-year-change': '+36.0%'
				},
				sales: {
					2025: 60,
					2024: 56,
					'one-year-change': '+7.1%'
				},
				days_on_market_average: {
					2025: 23,
					2024: 18,
					'one-year-change': '+27.8%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,244,200',
					2024: '$2,228,400',
					'one-year-change': '+0.7%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 401,
					2024: 238,
					'one-year-change': '+68.5%'
				},
				sales: {
					2025: 77,
					2024: 94,
					'one-year-change': '-18.1%'
				},
				days_on_market_average: {
					2025: 22,
					2024: 17,
					'one-year-change': '+29.4%'
				},
				mls_hpi_benchmark_price: {
					2025: '$817,700',
					2024: '$821,700',
					'one-year-change': '-0.5%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 121,
					2024: 81,
					'one-year-change': '+49.4%'
				},
				sales: {
					2025: 29,
					2024: 31,
					'one-year-change': '-6.5%'
				},
				days_on_market_average: {
					2025: 18,
					2024: 11,
					'one-year-change': '+63.6%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,313,200',
					2024: '$1,353,200',
					'one-year-change': '-3.0%'
				}
			}
		},
		'Vancouver West': {
			detached: {
				total_active_listings: {
					2025: 668,
					2024: 551,
					'one-year-change': '+21.2%'
				},
				sales: {
					2025: 52,
					2024: 63,
					'one-year-change': '-17.5%'
				},
				days_on_market_average: {
					2025: 42,
					2024: 34,
					'one-year-change': '+23.5%'
				},
				mls_hpi_benchmark_price: {
					2025: '$3,451,900',
					2024: '$3,447,700',
					'one-year-change': '+0.1%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 1952,
					2024: 1545,
					'one-year-change': '+26.3%'
				},
				sales: {
					2025: 292,
					2024: 302,
					'one-year-change': '-3.3%'
				},
				days_on_market_average: {
					2025: 30,
					2024: 32,
					'one-year-change': '-6.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$849,400',
					2024: '$842,100',
					'one-year-change': '+0.9%'
				}
			},
			townhomes: {
				total_active_listings: {
					2025: 295,
					2024: 233,
					'one-year-change': '+26.6%'
				},
				sales: {
					2025: 38,
					2024: 48,
					'one-year-change': '-20.8%'
				},
				days_on_market_average: {
					2025: 25,
					2024: 30,
					'one-year-change': '-16.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,478,800',
					2024: '$1,471,800',
					'one-year-change': '+0.5%'
				}
			}
		}
	},
	'April 2025': {
		'vancouver west': {
			detached: {
				total_active_listings: {
					2025: 740,
					2024: 620,
					'one-year-change': '+19.4%'
				},
				sales: {
					2025: 52,
					2024: 89,
					'one-year-change': '-41.6%'
				},
				days_on_market_average: {
					2025: 34,
					2024: 35,
					'one-year-change': '-2.9%'
				},
				mls_hpi_benchmark_price: {
					2025: '$3,427,100',
					2024: '$3,514,400',
					'one-year-change': '-2.5%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 2050,
					2024: 1852,
					'one-year-change': '+10.7%'
				},
				sales: {
					2025: 324,
					2024: 315,
					'one-year-change': '+2.9%'
				},
				days_on_market_average: {
					2025: 33,
					2024: 30,
					'one-year-change': '+10.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$847,200',
					2024: '$852,300',
					'one-year-change': '-0.6%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 331,
					2024: 277,
					'one-year-change': '+19.5%'
				},
				sales: {
					2025: 38,
					2024: 49,
					'one-year-change': '-22.4%'
				},
				days_on_market_average: {
					2025: 28,
					2024: 31,
					'one-year-change': '-9.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,424,700',
					2024: '$1,490,400',
					'one-year-change': '-4.4%'
				}
			}
		},
		'Burnaby South': {
			detached: {
				total_active_listings: {
					2025: 182,
					2024: 115,
					'one-year-change': '+58.3%'
				},
				sales: {
					2025: 18,
					2024: 26,
					'one-year-change': '-30.8%'
				},
				days_on_market_average: {
					2025: 43,
					2024: 40,
					'one-year-change': '+7.5%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,239,000',
					2024: '$2,243,100',
					'one-year-change': '-0.2%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 448,
					2024: 346,
					'one-year-change': '+29.5%'
				},
				sales: {
					2025: 67,
					2024: 93,
					'one-year-change': '-28.0%'
				},
				days_on_market_average: {
					2025: 44,
					2024: 21,
					'one-year-change': '+109.5%'
				},
				mls_hpi_benchmark_price: {
					2025: '$836,900',
					2024: '$846,400',
					'one-year-change': '-1.1%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 56,
					2024: 48,
					'one-year-change': '+16.7%'
				},
				sales: {
					2025: 9,
					2024: 19,
					'one-year-change': '-52.6%'
				},
				days_on_market_average: {
					2025: 38,
					2024: 16,
					'one-year-change': '+137.5%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,066,600',
					2024: '$1,097,200',
					'one-year-change': '-2.8%'
				}
			}
		},
		'Port Moody': {
			detached: {
				total_active_listings: {
					2025: 115,
					2024: 88,
					'one-year-change': '+30.7%'
				},
				sales: {
					2025: 14,
					2024: 11,
					'one-year-change': '+27.3%'
				},
				days_on_market_average: {
					2025: 49,
					2024: 11,
					'one-year-change': '+345.5%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,060,600',
					2024: '$2,149,400',
					'one-year-change': '-4.1%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 141,
					2024: 82,
					'one-year-change': '+72.0%'
				},
				sales: {
					2025: 22,
					2024: 33,
					'one-year-change': '-33.3%'
				},
				days_on_market_average: {
					2025: 22,
					2024: 36,
					'one-year-change': '-38.9%'
				},
				mls_hpi_benchmark_price: {
					2025: '$734,900',
					2024: '$741,500',
					'one-year-change': '-0.9%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 52,
					2024: 29,
					'one-year-change': '+79.3%'
				},
				sales: {
					2025: 13,
					2024: 25,
					'one-year-change': '-48.0%'
				},
				days_on_market_average: {
					2025: 16,
					2024: 12,
					'one-year-change': '+33.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,043,800',
					2024: '$1,047,400',
					'one-year-change': '-0.3%'
				}
			}
		},
		'Burnaby North': {
			detached: {
				total_active_listings: {
					2025: 193,
					2024: 117,
					'one-year-change': '+65.0%'
				},
				sales: {
					2025: 15,
					2024: 24,
					'one-year-change': '-37.5%'
				},
				days_on_market_average: {
					2025: 38,
					2024: 19,
					'one-year-change': '+100.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,171,000',
					2024: '$2,115,200',
					'one-year-change': '+2.6%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 648,
					2024: 527,
					'one-year-change': '+23.0%'
				},
				sales: {
					2025: 108,
					2024: 118,
					'one-year-change': '-8.5%'
				},
				days_on_market_average: {
					2025: 34,
					2024: 24,
					'one-year-change': '+41.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$743,400',
					2024: '$769,400',
					'one-year-change': '-3.4%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 58,
					2024: 49,
					'one-year-change': '+18.4%'
				},
				sales: {
					2025: 16,
					2024: 15,
					'one-year-change': '+6.7%'
				},
				days_on_market_average: {
					2025: 22,
					2024: 20,
					'one-year-change': '+10.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$912,100',
					2024: '$923,100',
					'one-year-change': '-1.2%'
				}
			}
		},
		'Vancouver East': {
			detached: {
				total_active_listings: {
					2025: '677',
					2024: '537',
					'one-year-change': '+26.1%'
				},
				sales: {
					2025: '67',
					2024: '117',
					'one-year-change': '-42.7%'
				},
				days_on_market_average: {
					2025: '25',
					2024: '16',
					'one-year-change': '+56.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,852,000',
					2024: '$1,861,100',
					'one-year-change': '-0.5%'
				}
			},
			condo: {
				total_active_listings: {
					2025: '601',
					2024: '524',
					'one-year-change': '+14.7%'
				},
				sales: {
					2025: '110',
					2024: '142',
					'one-year-change': '-22.5%'
				},
				days_on_market_average: {
					2025: '24',
					2024: '22',
					'one-year-change': '+9.1%'
				},
				mls_hpi_benchmark_price: {
					2025: '$703,600',
					2024: '$718,600',
					'one-year-change': '-2.1%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: '131',
					2024: '117',
					'one-year-change': '+12.0%'
				},
				sales: {
					2025: '22',
					2024: '28',
					'one-year-change': '-21.4%'
				},
				days_on_market_average: {
					2025: '27',
					2024: '38',
					'one-year-change': '-28.9%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,128,400',
					2024: '$1,143,800',
					'one-year-change': '-1.3%'
				}
			}
		},
		'Maple ridge': {
			detached: {
				total_active_listings: {
					2025: '574',
					2024: '462',
					'one-year-change': '+19.1%'
				},
				sales: {
					2025: '63',
					2024: '92',
					'one-year-change': '-31.5%'
				},
				days_on_market_average: {
					2025: '26',
					2024: '25',
					'one-year-change': '+4.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,304,200',
					2024: '$1,295,900',
					'one-year-change': '+0.6%'
				}
			},
			condo: {
				total_active_listings: {
					2025: '162',
					2024: '216',
					'one-year-change': '-25.0%'
				},
				sales: {
					2025: '33',
					2024: '38',
					'one-year-change': '-13.2%'
				},
				days_on_market_average: {
					2025: '43',
					2024: '30',
					'one-year-change': '+43.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$518,900',
					2024: '$543,400',
					'one-year-change': '-4.5%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: '139',
					2024: '122',
					'one-year-change': '+13.9%'
				},
				sales: {
					2025: '30',
					2024: '55',
					'one-year-change': '-45.5%'
				},
				days_on_market_average: {
					2025: '16',
					2024: '18',
					'one-year-change': '-11.1%'
				},
				mls_hpi_benchmark_price: {
					2025: '$781,400',
					2024: '$788,000',
					'one-year-change': '-0.8%'
				}
			}
		},
		whistler: {
			detached: {
				total_active_listings: {
					2025: 88,
					2024: 79,
					'one-year-change': '+11.4%'
				},
				sales: {
					2025: 4,
					2024: 6,
					'one-year-change': '-33.3%'
				},
				days_on_market_average: {
					2025: 205,
					2024: 74,
					'one-year-change': '+177.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,617,200',
					2024: '$2,416,900',
					'one-year-change': '+8.3%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 128,
					2024: 103,
					'one-year-change': '+24.3%'
				},
				sales: {
					2025: 15,
					2024: 40,
					'one-year-change': '-62.5%'
				},
				days_on_market_average: {
					2025: 97,
					2024: 42,
					'one-year-change': '+131.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$659,300',
					2024: '$708,500',
					'one-year-change': '-6.9%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 89,
					2024: 98,
					'one-year-change': '-9.2%'
				},
				sales: {
					2025: 15,
					2024: 10,
					'one-year-change': '+50.0%'
				},
				days_on_market_average: {
					2025: 64,
					2024: 25,
					'one-year-change': '+156.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,642,100',
					2024: '$1,762,700',
					'one-year-change': '-6.8%'
				}
			}
		},
		'metro vancouver': {
			detached: {
				total_active_listings: {
					2025: 5969,
					2024: 4877,
					'one-year-change': '+22.4%'
				},
				sales: {
					2025: 580,
					2024: 812,
					'one-year-change': '-28.6%'
				},
				days_on_market_average: {
					2025: 35,
					2024: 32,
					'one-year-change': '+9.4%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,021,800',
					2024: '$2,035,400',
					'one-year-change': '-0.7%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 7118,
					2024: 5568,
					'one-year-change': '+27.8%'
				},
				sales: {
					2025: 1134,
					2024: 1419,
					'one-year-change': '-20.1%'
				},
				days_on_market_average: {
					2025: 31,
					2024: 25,
					'one-year-change': '+24.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$762,800',
					2024: '$778,300',
					'one-year-change': '-2.0%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 1898,
					2024: 1425,
					'one-year-change': '+33.2%'
				},
				sales: {
					2025: 355,
					2024: 455,
					'one-year-change': '-22.0%'
				},
				days_on_market_average: {
					2025: 25,
					2024: 20,
					'one-year-change': '+25.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,102,300',
					2024: '$1,135,300',
					'one-year-change': '-2.9%'
				}
			}
		},
		'New Westminster': {
			detached: {
				total_active_listings: {
					2025: '128',
					2024: '121',
					'one-year-change': '+5.8%'
				},
				sales: {
					2025: '13',
					2024: '12',
					'one-year-change': '+8.3%'
				},
				days_on_market_average: {
					2025: '34',
					2024: '24',
					'one-year-change': '+41.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,595,400',
					2024: '$1,602,800',
					'one-year-change': '-0.5%'
				}
			},
			condo: {
				total_active_listings: {
					2025: '366',
					2024: '245',
					'one-year-change': '+49.4%'
				},
				sales: {
					2025: '64',
					2024: '77',
					'one-year-change': '-16.9%'
				},
				days_on_market_average: {
					2025: '29',
					2024: '21',
					'one-year-change': '+38.1%'
				},
				mls_hpi_benchmark_price: {
					2025: '$649,200',
					2024: '$660,000',
					'one-year-change': '-1.6%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: '58',
					2024: '38',
					'one-year-change': '+52.6%'
				},
				sales: {
					2025: '10',
					2024: '15',
					'one-year-change': '-33.3%'
				},
				days_on_market_average: {
					2025: '24',
					2024: '13',
					'one-year-change': '+84.6%'
				},
				mls_hpi_benchmark_price: {
					2025: '$929,900',
					2024: '$954,100',
					'one-year-change': '-2.5%'
				}
			}
		},
		'Port Coquitlam': {
			detached: {
				total_active_listings: {
					2025: 160,
					2024: 126,
					'one-year-change': '+27.0%'
				},
				sales: {
					2025: 27,
					2024: 35,
					'one-year-change': '-22.9%'
				},
				days_on_market_average: {
					2025: 45,
					2024: 18,
					'one-year-change': '+150.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,408,900',
					2024: '$1,438,700',
					'one-year-change': '-2.1%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 125,
					2024: 80,
					'one-year-change': '+56.3%'
				},
				sales: {
					2025: 24,
					2024: 46,
					'one-year-change': '-47.8%'
				},
				days_on_market_average: {
					2025: 16,
					2024: 16,
					'one-year-change': '0.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$641,100',
					2024: '$640,900',
					'one-year-change': '+0.0%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 56,
					2024: 39,
					'one-year-change': '+43.6%'
				},
				sales: {
					2025: 18,
					2024: 21,
					'one-year-change': '-14.3%'
				},
				days_on_market_average: {
					2025: 18,
					2024: 12,
					'one-year-change': '+50.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$955,400',
					2024: '$965,900',
					'one-year-change': '-1.1%'
				}
			}
		},
		squamish: {
			detached: {
				total_active_listings: {
					2025: 83,
					2024: 101,
					'one-year-change': '-17.8%'
				},
				sales: {
					2025: 25,
					2024: 12,
					'one-year-change': '+108.3%'
				},
				days_on_market_average: {
					2025: 24,
					2024: 50,
					'one-year-change': '-52.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,661,500',
					2024: '$1,524,600',
					'one-year-change': '+9.0%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 72,
					2024: 50,
					'one-year-change': '+44.0%'
				},
				sales: {
					2025: 19,
					2024: 16,
					'one-year-change': '+18.8%'
				},
				days_on_market_average: {
					2025: 24,
					2024: 89,
					'one-year-change': '-73.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$621,600',
					2024: '$626,500',
					'one-year-change': '-0.8%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 41,
					2024: 29,
					'one-year-change': '+41.4%'
				},
				sales: {
					2025: 20,
					2024: 20,
					'one-year-change': '0.0%'
				},
				days_on_market_average: {
					2025: 31,
					2024: 28,
					'one-year-change': '+10.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,040,700',
					2024: '$1,082,300',
					'one-year-change': '-3.8%'
				}
			}
		},
		Tsawwassen: {
			detached: {
				total_active_listings: {
					2025: '167',
					2024: '111',
					'one-year-change': '+50.5%'
				},
				sales: {
					2025: '19',
					2024: '19',
					'one-year-change': '0.0%'
				},
				days_on_market_average: {
					2025: '23',
					2024: '40',
					'one-year-change': '-42.5%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,620,500',
					2024: '$1,678,300',
					'one-year-change': '-3.4%'
				}
			},
			condo: {
				total_active_listings: {
					2025: '83',
					2024: '53',
					'one-year-change': '+56.6%'
				},
				sales: {
					2025: '14',
					2024: '19',
					'one-year-change': '-26.3%'
				},
				days_on_market_average: {
					2025: '29',
					2024: '26',
					'one-year-change': '+11.5%'
				},
				mls_hpi_benchmark_price: {
					2025: '$673,500',
					2024: '$697,100',
					'one-year-change': '-3.4%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: '45',
					2024: '24',
					'one-year-change': '+87.5%'
				},
				sales: {
					2025: '6',
					2024: '11',
					'one-year-change': '-45.5%'
				},
				days_on_market_average: {
					2025: '39',
					2024: '44',
					'one-year-change': '-11.4%'
				},
				mls_hpi_benchmark_price: {
					2025: '$988,000',
					2024: '$1,017,800',
					'one-year-change': '-2.9%'
				}
			}
		},
		'West Vancouver': {
			detached: {
				total_active_listings: {
					2025: '529',
					2024: '483',
					'one-year-change': '+9.5%'
				},
				sales: {
					2025: '26',
					2024: '43',
					'one-year-change': '-39.5%'
				},
				days_on_market_average: {
					2025: '47',
					2024: '52',
					'one-year-change': '-9.6%'
				},
				mls_hpi_benchmark_price: {
					2025: '$3,345,300',
					2024: '$3,243,500',
					'one-year-change': '+3.1%'
				}
			},
			condo: {
				total_active_listings: {
					2025: '129',
					2024: '111',
					'one-year-change': '+16.2%'
				},
				sales: {
					2025: '10',
					2024: '24',
					'one-year-change': '-58.3%'
				},
				days_on_market_average: {
					2025: '28',
					2024: '19',
					'one-year-change': '+47.4%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,216,700',
					2024: '$1,334,600',
					'one-year-change': '-8.8%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: '29',
					2024: '23',
					'one-year-change': '+26.1%'
				},
				sales: {
					2025: '1',
					2024: '1',
					'one-year-change': '0.0%'
				},
				days_on_market_average: {
					2025: '33',
					2024: '24',
					'one-year-change': '+37.5%'
				},
				mls_hpi_benchmark_price: {
					2025: '$0',
					2024: '$0',
					'one-year-change': '--'
				}
			}
		},
		'sunshine coast': {
			detached: {
				total_active_listings: {
					2025: 452,
					2024: 402,
					'one-year-change': '+12.4%'
				},
				sales: {
					2025: 41,
					2024: 51,
					'one-year-change': '-19.6%'
				},
				days_on_market_average: {
					2025: 68,
					2024: 74,
					'one-year-change': '-8.1%'
				},
				mls_hpi_benchmark_price: {
					2025: '$840,000',
					2024: '$889,900',
					'one-year-change': '-5.6%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 43,
					2024: 29,
					'one-year-change': '+48.3%'
				},
				sales: {
					2025: 7,
					2024: 6,
					'one-year-change': '+16.7%'
				},
				days_on_market_average: {
					2025: 99,
					2024: 12,
					'one-year-change': '+725.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$507,500',
					2024: '$531,500',
					'one-year-change': '-4.5%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 34,
					2024: 28,
					'one-year-change': '+21.4%'
				},
				sales: {
					2025: 4,
					2024: 7,
					'one-year-change': '-42.9%'
				},
				days_on_market_average: {
					2025: 94,
					2024: 24,
					'one-year-change': '+291.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$753,700',
					2024: '$783,700',
					'one-year-change': '-3.8%'
				}
			}
		},
		Ladner: {
			detached: {
				total_active_listings: {
					2025: 101,
					2024: 79,
					'one-year-change': '+27.8%'
				},
				sales: {
					2025: 7,
					2024: 15,
					'one-year-change': '-53.3%'
				},
				days_on_market_average: {
					2025: 44,
					2024: 60,
					'one-year-change': '-26.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,408,900',
					2024: '$1,442,700',
					'one-year-change': '-2.3%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 20,
					2024: 15,
					'one-year-change': '+33.3%'
				},
				sales: {
					2025: 5,
					2024: 5,
					'one-year-change': '0.0%'
				},
				days_on_market_average: {
					2025: 11,
					2024: 20,
					'one-year-change': '-45.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$686,800',
					2024: '$684,300',
					'one-year-change': '+0.4%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 46,
					2024: 25,
					'one-year-change': '+84.0%'
				},
				sales: {
					2025: 4,
					2024: 12,
					'one-year-change': '-66.7%'
				},
				days_on_market_average: {
					2025: 18,
					2024: 4,
					'one-year-change': '+350.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,024,300',
					2024: '$1,022,300',
					'one-year-change': '+0.2%'
				}
			}
		},
		Richmond: {
			detached: {
				total_active_listings: {
					2025: 612,
					2024: 515,
					'one-year-change': '+18.8%'
				},
				sales: {
					2025: 47,
					2024: 86,
					'one-year-change': '-45.3%'
				},
				days_on_market_average: {
					2025: 38,
					2024: 35,
					'one-year-change': '+8.6%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,155,200',
					2024: '$2,206,800',
					'one-year-change': '-2.3%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 935,
					2024: 625,
					'one-year-change': '+49.6%'
				},
				sales: {
					2025: 117,
					2024: 181,
					'one-year-change': '-35.4%'
				},
				days_on_market_average: {
					2025: 30,
					2024: 24,
					'one-year-change': '+25.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$732,500',
					2024: '$761,100',
					'one-year-change': '-3.8%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 332,
					2024: 206,
					'one-year-change': '+61.2%'
				},
				sales: {
					2025: 49,
					2024: 60,
					'one-year-change': '-18.3%'
				},
				days_on_market_average: {
					2025: 28,
					2024: 19,
					'one-year-change': '+47.4%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,110,300',
					2024: '$1,154,700',
					'one-year-change': '-3.8%'
				}
			}
		},
		'Bowen island': {
			detached: {
				total_active_listings: {
					2025: '57',
					2024: '45',
					'one-year-change': '+26.7%'
				},
				sales: {
					2025: '4',
					2024: '4',
					'one-year-change': '0.0%'
				},
				days_on_market_average: {
					2025: '157',
					2024: '46',
					'one-year-change': '+241.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,334,000',
					2024: '$1,405,500',
					'one-year-change': '-5.1%'
				}
			},
			condo: {
				total_active_listings: {
					2025: '0',
					2024: '0',
					'one-year-change': '--'
				},
				sales: {
					2025: '0',
					2024: '0',
					'one-year-change': '--'
				},
				days_on_market_average: {
					2025: '0',
					2024: '0',
					'one-year-change': '--'
				},
				mls_hpi_benchmark_price: {
					2025: '$0',
					2024: '$0',
					'one-year-change': '--'
				}
			},
			townhome: {
				total_active_listings: {
					2025: '0',
					2024: '0',
					'one-year-change': '--'
				},
				sales: {
					2025: '0',
					2024: '0',
					'one-year-change': '--'
				},
				days_on_market_average: {
					2025: '0',
					2024: '0',
					'one-year-change': '--'
				},
				mls_hpi_benchmark_price: {
					2025: '$0',
					2024: '$0',
					'one-year-change': '--'
				}
			}
		},
		'Pitt Meadows': {
			detached: {
				total_active_listings: {
					2025: 57,
					2024: 41,
					'one-year-change': '+39.0%'
				},
				sales: {
					2025: 11,
					2024: 16,
					'one-year-change': '-31.3%'
				},
				days_on_market_average: {
					2025: 13,
					2024: 32,
					'one-year-change': '-59.4%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,302,600',
					2024: '$1,333,700',
					'one-year-change': '-2.3%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 38,
					2024: 16,
					'one-year-change': '+137.5%'
				},
				sales: {
					2025: 5,
					2024: 4,
					'one-year-change': '+25.0%'
				},
				days_on_market_average: {
					2025: 15,
					2024: 8,
					'one-year-change': '+87.5%'
				},
				mls_hpi_benchmark_price: {
					2025: '$595,500',
					2024: '$621,000',
					'one-year-change': '-4.1%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 26,
					2024: 23,
					'one-year-change': '+13.0%'
				},
				sales: {
					2025: 9,
					2024: 10,
					'one-year-change': '-10.0%'
				},
				days_on_market_average: {
					2025: 14,
					2024: 12,
					'one-year-change': '+16.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$844,000',
					2024: '$864,200',
					'one-year-change': '-2.3%'
				}
			}
		},
		'Burnaby east': {
			detached: {
				total_active_listings: {
					2025: 51,
					2024: 40,
					'one-year-change': '+27.5%'
				},
				sales: {
					2025: 5,
					2024: 6,
					'one-year-change': '-16.7%'
				},
				days_on_market_average: {
					2025: 31,
					2024: 20,
					'one-year-change': '+55.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,969,200',
					2024: '$1,951,700',
					'one-year-change': '+0.9%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 89,
					2024: 59,
					'one-year-change': '+50.8%'
				},
				sales: {
					2025: 16,
					2024: 14,
					'one-year-change': '+14.3%'
				},
				days_on_market_average: {
					2025: 26,
					2024: 22,
					'one-year-change': '+18.2%'
				},
				mls_hpi_benchmark_price: {
					2025: '$789,200',
					2024: '$813,800',
					'one-year-change': '-3.0%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 40,
					2024: 15,
					'one-year-change': '+166.7%'
				},
				sales: {
					2025: 3,
					2024: 8,
					'one-year-change': '-62.5%'
				},
				days_on_market_average: {
					2025: 32,
					2024: 15,
					'one-year-change': '+113.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$921,400',
					2024: '$906,100',
					'one-year-change': '+1.7%'
				}
			}
		},
		Coquitlam: {
			detached: {
				total_active_listings: {
					2025: 511,
					2024: 352,
					'one-year-change': '+45.2%'
				},
				sales: {
					2025: 46,
					2024: 64,
					'one-year-change': '-28.1%'
				},
				days_on_market_average: {
					2025: 23,
					2024: 24,
					'one-year-change': '-4.2%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,792,100',
					2024: '$1,847,700',
					'one-year-change': '-3.0%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 572,
					2024: 321,
					'one-year-change': '+78.2%'
				},
				sales: {
					2025: 78,
					2024: 127,
					'one-year-change': '-38.6%'
				},
				days_on_market_average: {
					2025: 25,
					2024: 23,
					'one-year-change': '+8.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$729,100',
					2024: '$754,900',
					'one-year-change': '-3.4%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 193,
					2024: 130,
					'one-year-change': '+48.5%'
				},
				sales: {
					2025: 60,
					2024: 39,
					'one-year-change': '+53.8%'
				},
				days_on_market_average: {
					2025: 17,
					2024: 14,
					'one-year-change': '+21.4%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,081,400',
					2024: '$1,080,500',
					'one-year-change': '+0.1%'
				}
			}
		},
		'North Vancouver': {
			detached: {
				total_active_listings: {
					2025: '364',
					2024: '288',
					'one-year-change': '+26.4%'
				},
				sales: {
					2025: '73',
					2024: '76',
					'one-year-change': '-3.9%'
				},
				days_on_market_average: {
					2025: '17',
					2024: '13',
					'one-year-change': '+30.8%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,199,000',
					2024: '$2,256,800',
					'one-year-change': '-2.6%'
				}
			},
			condo: {
				total_active_listings: {
					2025: '457',
					2024: '303',
					'one-year-change': '+50.8%'
				},
				sales: {
					2025: '96',
					2024: '117',
					'one-year-change': '-17.9%'
				},
				days_on_market_average: {
					2025: '22',
					2024: '19',
					'one-year-change': '+15.8%'
				},
				mls_hpi_benchmark_price: {
					2025: '$815,200',
					2024: '$823,300',
					'one-year-change': '-1.0%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: '138',
					2024: '98',
					'one-year-change': '+40.8%'
				},
				sales: {
					2025: '24',
					2024: '49',
					'one-year-change': '-51.0%'
				},
				days_on_market_average: {
					2025: '20',
					2024: '13',
					'one-year-change': '+53.8%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,325,300',
					2024: '$1,387,300',
					'one-year-change': '-4.5%'
				}
			}
		}
	},
	'May 2025': {
		'Maple Ridge': {
			detached: {
				total_active_listings: {
					2025: 618,
					2024: 515,
					'one-year-change': '+ 20.0%'
				},
				sales: {
					2025: 71,
					2024: 86,
					'one-year-change': '- 17.4%'
				},
				days_on_market_average: {
					2025: 36,
					2024: 20,
					'one-year-change': '+ 80.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,287,300',
					2024: '$1,301,400',
					'one-year-change': '- 1.1%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 166,
					2024: 215,
					'one-year-change': '- 22.8%'
				},
				sales: {
					2025: 27,
					2024: 34,
					'one-year-change': '- 20.6%'
				},
				days_on_market_average: {
					2025: 37,
					2024: 34,
					'one-year-change': '+ 8.8%'
				},
				mls_hpi_benchmark_price: {
					2025: '$525,000',
					2024: '$543,200',
					'one-year-change': '- 3.4%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 160,
					2024: 131,
					'one-year-change': '+ 22.1%'
				},
				sales: {
					2025: 35,
					2024: 52,
					'one-year-change': '- 32.7%'
				},
				days_on_market_average: {
					2025: 18,
					2024: 17,
					'one-year-change': '+ 5.9%'
				},
				mls_hpi_benchmark_price: {
					2025: '$784,400',
					2024: '$791,500',
					'one-year-change': '- 0.9%'
				}
			}
		},
		Coquitlam: {
			detached: {
				total_active_listings: {
					2025: 559,
					2024: 382,
					'one-year-change': '+ 46.3%'
				},
				sales: {
					2025: 55,
					2024: 78,
					'one-year-change': '- 29.5%'
				},
				days_on_market_average: {
					2025: 23,
					2024: 18,
					'one-year-change': '+ 27.8%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,778,300',
					2024: '$1,854,400',
					'one-year-change': '- 4.1%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 537,
					2024: 392,
					'one-year-change': '+ 37.0%'
				},
				sales: {
					2025: 98,
					2024: 102,
					'one-year-change': '- 3.9%'
				},
				days_on_market_average: {
					2025: 32,
					2024: 19,
					'one-year-change': '+ 68.4%'
				},
				mls_hpi_benchmark_price: {
					2025: '$724,000',
					2024: '$751,900',
					'one-year-change': '- 3.7%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 207,
					2024: 152,
					'one-year-change': '+ 36.2%'
				},
				sales: {
					2025: 34,
					2024: 40,
					'one-year-change': '- 15.0%'
				},
				days_on_market_average: {
					2025: 19,
					2024: 16,
					'one-year-change': '+ 18.8%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,085,000',
					2024: '$1,096,900',
					'one-year-change': '- 1.1%'
				}
			}
		},
		'Vancouver East': {
			detached: {
				total_active_listings: {
					2025: 730,
					2024: 577,
					'one-year-change': '+ 26.5%'
				},
				sales: {
					2025: 72,
					2024: 104,
					'one-year-change': '- 30.8%'
				},
				days_on_market_average: {
					2025: 32,
					2024: 17,
					'one-year-change': '+ 88.2%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,828,600',
					2024: '$1,879,000',
					'one-year-change': '- 2.7%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 624,
					2024: 561,
					'one-year-change': '+ 11.2%'
				},
				sales: {
					2025: 102,
					2024: 138,
					'one-year-change': '- 26.1%'
				},
				days_on_market_average: {
					2025: 24,
					2024: 22,
					'one-year-change': '+ 9.1%'
				},
				mls_hpi_benchmark_price: {
					2025: '$696,000',
					2024: '$719,200',
					'one-year-change': '- 3.2%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 127,
					2024: 117,
					'one-year-change': '+ 8.5%'
				},
				sales: {
					2025: 31,
					2024: 42,
					'one-year-change': '- 26.2%'
				},
				days_on_market_average: {
					2025: 25,
					2024: 17,
					'one-year-change': '+ 47.1%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,120,900',
					2024: '$1,134,500',
					'one-year-change': '- 1.2%'
				}
			}
		},
		'Burnaby North': {
			detached: {
				total_active_listings: {
					2025: 215,
					2024: 130,
					'one-year-change': '+ 65.4%'
				},
				sales: {
					2025: 22,
					2024: 36,
					'one-year-change': '- 38.9%'
				},
				days_on_market_average: {
					2025: 30,
					2024: 15,
					'one-year-change': '+ 100.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,094,100',
					2024: '$2,154,100',
					'one-year-change': '- 2.8%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 649,
					2024: 559,
					'one-year-change': '+ 16.1%'
				},
				sales: {
					2025: 94,
					2024: 107,
					'one-year-change': '- 12.1%'
				},
				days_on_market_average: {
					2025: 31,
					2024: 25,
					'one-year-change': '+ 24.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$736,200',
					2024: '$759,400',
					'one-year-change': '- 3.1%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 53,
					2024: 57,
					'one-year-change': '- 7.0%'
				},
				sales: {
					2025: 17,
					2024: 21,
					'one-year-change': '- 19.0%'
				},
				days_on_market_average: {
					2025: 29,
					2024: 19,
					'one-year-change': '+ 52.6%'
				},
				mls_hpi_benchmark_price: {
					2025: '$919,200',
					2024: '$928,600',
					'one-year-change': '- 1.0%'
				}
			}
		}
	},
	'June 2025': {
		'Maple Ridge': {
			detached: {
				total_active_listings: {
					2025: 646,
					2024: 545,
					'one-year-change': '+ 18.5%'
				},
				sales: {
					2025: 58,
					2024: 70,
					'one-year-change': '- 17.1%'
				},
				days_on_market_average: {
					2025: 46,
					2024: 21,
					'one-year-change': '+ 119.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,282,700',
					2024: '$1,302,200',
					'one-year-change': '- 1.5%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 167,
					2024: 205,
					'one-year-change': '- 18.5%'
				},
				sales: {
					2025: 27,
					2024: 31,
					'one-year-change': '- 12.9%'
				},
				days_on_market_average: {
					2025: 48,
					2024: 28,
					'one-year-change': '+ 71.4%'
				},
				mls_hpi_benchmark_price: {
					2025: '$514,600',
					2024: '$534,900',
					'one-year-change': '- 3.8%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 158,
					2024: 152,
					'one-year-change': '+ 3.9%'
				},
				sales: {
					2025: 38,
					2024: 27,
					'one-year-change': '+ 40.7%'
				},
				days_on_market_average: {
					2025: 25,
					2024: 18,
					'one-year-change': '+ 38.9%'
				},
				mls_hpi_benchmark_price: {
					2025: '$773,300',
					2024: '$792,100',
					'one-year-change': '- 2.4%'
				}
			}
		},
		Coquitlam: {
			detached: {
				total_active_listings: {
					2025: 560,
					2024: 407,
					'one-year-change': '+ 37.6%'
				},
				sales: {
					2025: 48,
					2024: 54,
					'one-year-change': '- 11.1%'
				},
				days_on_market_average: {
					2025: 30,
					2024: 24,
					'one-year-change': '+ 25.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,750,600',
					2024: '$1,842,600',
					'one-year-change': '- 5.0%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 550,
					2024: 414,
					'one-year-change': '+ 32.9%'
				},
				sales: {
					2025: 78,
					2024: 94,
					'one-year-change': '- 17.0%'
				},
				days_on_market_average: {
					2025: 37,
					2024: 23,
					'one-year-change': '+ 60.9%'
				},
				mls_hpi_benchmark_price: {
					2025: '$710,800',
					2024: '$746,400',
					'one-year-change': '- 4.8%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 213,
					2024: 145,
					'one-year-change': '+ 46.9%'
				},
				sales: {
					2025: 40,
					2024: 39,
					'one-year-change': '+ 2.6%'
				},
				days_on_market_average: {
					2025: 20,
					2024: 22,
					'one-year-change': '- 9.1%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,096,600',
					2024: '$1,084,200',
					'one-year-change': '+ 1.1%'
				}
			}
		},
		'Vancouver East': {
			detached: {
				total_active_listings: {
					2025: '736',
					2024: '614',
					'one-year-change': '+ 19.9%'
				},
				sales: {
					2025: '96',
					2024: '75',
					'one-year-change': '+ 28.0%'
				},
				days_on_market_average: {
					2025: '33',
					2024: '22',
					'one-year-change': '+ 50.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,831,800',
					2024: '$1,892,600',
					'one-year-change': '- 3.2%'
				}
			},
			condo: {
				total_active_listings: {
					2025: '623',
					2024: '574',
					'one-year-change': '+ 8.5%'
				},
				sales: {
					2025: '106',
					2024: '127',
					'one-year-change': '- 15.0%'
				},
				days_on_market_average: {
					2025: '29',
					2024: '21',
					'one-year-change': '+ 38.1%'
				},
				mls_hpi_benchmark_price: {
					2025: '$686,500',
					2024: '$711,300',
					'one-year-change': '- 3.5%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: '140',
					2024: '115',
					'one-year-change': '+ 21.7%'
				},
				sales: {
					2025: '27',
					2024: '27',
					'one-year-change': '0.0%'
				},
				days_on_market_average: {
					2025: '23',
					2024: '25',
					'one-year-change': '- 8.0%'
				},
				mls_hpi_benchmark_price: {
					2025: '$1,104,400',
					2024: '$1,147,600',
					'one-year-change': '- 3.8%'
				}
			}
		},
		'Burnaby North': {
			detached: {
				total_active_listings: {
					2025: 230,
					2024: 136,
					'one-year-change': '+ 69.1%'
				},
				sales: {
					2025: 16,
					2024: 30,
					'one-year-change': '- 46.7%'
				},
				days_on_market_average: {
					2025: 33,
					2024: 36,
					'one-year-change': '- 8.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$2,131,900',
					2024: '$2,173,900',
					'one-year-change': '- 1.9%'
				}
			},
			condo: {
				total_active_listings: {
					2025: 623,
					2024: 594,
					'one-year-change': '+ 4.9%'
				},
				sales: {
					2025: 87,
					2024: 115,
					'one-year-change': '- 24.3%'
				},
				days_on_market_average: {
					2025: 38,
					2024: 24,
					'one-year-change': '+ 58.3%'
				},
				mls_hpi_benchmark_price: {
					2025: '$724,900',
					2024: '$759,600',
					'one-year-change': '- 4.6%'
				}
			},
			townhome: {
				total_active_listings: {
					2025: 57,
					2024: 58,
					'one-year-change': '- 1.7%'
				},
				sales: {
					2025: 12,
					2024: 20,
					'one-year-change': '- 40.0%'
				},
				days_on_market_average: {
					2025: 28,
					2024: 15,
					'one-year-change': '+ 86.7%'
				},
				mls_hpi_benchmark_price: {
					2025: '$930,700',
					2024: '$955,500',
					'one-year-change': '- 2.6%'
				}
			}
		}
	}
};
